import React, { useState, useEffect } from 'react';
import { ProgressBar, Row, Col } from 'react-bootstrap';

const BarraDeProgresso = ({ total, valor, height, className, variant }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if(valor>=0 && total>0){
      const targetProgress = (parseFloat(valor) / parseFloat(total)) * 100; // Calcula a porcentagem desejada
      const duration = 500; // Duração em milissegundos
      const steps = 50; // Número de passos de animação (quanto mais alto, mais suave)
      const increment = targetProgress / steps; // Incremento por passo
      const stepInterval = duration / steps; // Intervalo entre cada incremento
  
      const interval = setInterval(() => {
        setProgress((prev) => {
          if (prev >= targetProgress) {
            clearInterval(interval);
            return targetProgress;
          }
          return prev + increment;
        });
      }, stepInterval);
  
      return () => clearInterval(interval);
    }
  }, [total, valor]);

  return (
    <Row>
      <Col>
        <ProgressBar
          now={progress}
          label={`${Math.round(progress)}%`}
          className={className}
          variant={variant}
          style={{ height: height }} // Define a altura da barra
        />
      </Col>
    </Row>
  );
};

export default BarraDeProgresso;